'use strict';

namespace Core {

    class NumberPicker implements ng.IDirective {
        restrict = 'E';
        replace = true;
        require = 'ngModel';
        scope = {
            model: '=ngModel',
            max: '=',
            min: '=',
            increment: '=',
            disabled: '@',
            onChange: '&'
        };

        template = `<div class="number-picker">
                        <a  href="#" 
                            ng-click="click.decrease()" 
                            ng-disabled="model <= min || disabled === 'true'" 
                            class="number-picker-part number-picker-minus">
                        </a>
                        <span 
                            class="number-picker-part number-picker-label">
                            {{model || 0}}
                        </span>
                        <a  href="#" 
                            ng-click="click.increase()" 
                            ng-disabled="model >= max || disabled === 'true'" 
                            class="number-picker-part number-picker-plus">
                        </a>
                    </div>`;

        constructor() {

        }

        link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel) => {
            const radix: number = 10;
            const increment = parseInt(scope.increment || 1, radix);
            let max: number = parseInt(scope.max, radix);
            let min: number = parseInt(scope.min, radix);

            if (scope.disabled !== 'true') {
                scope.$watch('max', (val) => {
                    max = Number(val);
                });
                scope.$watch('min', (val) => {
                    min = Number(val);
                });
            }

            if (scope.model === undefined) {
                ngModel.$setViewValue(0);
            }

            if (scope.disabled === 'true') {
                max = min = scope.model;
            }

            if (scope.onChange) {
                scope.$watch('model', function() {
                    scope.onChange();
                });
            }

            scope.click = {
                increase: () => {
                    if (scope.disabled === 'true') { return; }
                    if (scope.model < max) {
                        ngModel.$setViewValue(Number(scope.model) + increment);
                    }
                },
                decrease: () => {
                    if (scope.disabled === 'true') { return; }
                    if (scope.model > min) {
                        ngModel.$setViewValue(Number(scope.model) - increment);
                    }
                }
            };

        }

        static factory(): ng.IDirectiveFactory {
            const directive = () => new NumberPicker();
            directive.$inject = [];
            return directive;
        }
    }

    const TR = angular.module('TR');
    TR.directive('numberPicker', NumberPicker.factory());

}
